import React, { useState } from 'react';
import { CalendarClock, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { suppliersAPI } from '../services/api';

// Admin: record a new delivery date promised by the supplier for a late purchase order
const RescheduleModal = ({ po, onClose, onSaved }) => {
  const [date, setDate] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const today = new Date().toISOString().slice(0, 10);

  const save = async () => {
    if (!date) { toast.error('Choisissez la nouvelle date promise'); return; }
    setSaving(true);
    try {
      const r = await suppliersAPI.reschedulePurchaseOrder(po.id, date, note);
      toast.success(r.message);
      onSaved(r);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Enregistrement impossible');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md" data-testid="reschedule-modal">
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="font-bold text-gray-900 flex items-center gap-2"><CalendarClock size={18} className="text-orange-500" /> Nouvelle date fournisseur — {po.number}</h3>
          <button type="button" onClick={onClose} data-testid="reschedule-close" className="text-gray-400 hover:text-gray-700"><X size={20} /></button>
        </div>
        <div className="p-4 space-y-3">
          <p className="text-sm text-gray-600">Date initialement prévue : <strong>{po.expected_date ? new Date(po.expected_date).toLocaleDateString('fr-FR') : '—'}</strong>{po.days_late ? <span className="text-red-600"> (+{po.days_late} j)</span> : null}. L'alerte de retard disparaîtra jusqu'à la nouvelle date.</p>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Nouvelle date de livraison promise *</label>
            <Input data-testid="reschedule-date" type="date" min={today} value={date} onChange={(e) => setDate(e.target.value)} />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Note (réponse du fournisseur)</label>
            <textarea data-testid="reschedule-note" value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={300} className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm" placeholder="Rupture chez le fabricant, réexpédition confirmée…" />
          </div>
        </div>
        <div className="p-4 border-t flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} data-testid="reschedule-cancel">Annuler</Button>
          <Button onClick={save} disabled={saving || !date} data-testid="reschedule-save" className="bg-[#1e3a5f] hover:bg-[#2d4a6f]">{saving ? <Loader2 size={16} className="mr-2 animate-spin" /> : <CalendarClock size={16} className="mr-2" />} Enregistrer</Button>
        </div>
      </div>
    </div>
  );
};

export default RescheduleModal;
